export class CheckNotes {
  addNotesToReport: boolean;
  notes: string;
}

export class SummaryNotes extends CheckNotes {
  subNotes?: CheckNotes[] = [];
}

export class InspectionCaseDto {
  title?: string;
  isTitle?: boolean;
  section?: string;
  isApplicable?: boolean;
  notes?: CheckNotes[];
  images?: string[];
  isPassed?: boolean;
  multiNotes?: SummaryNotes[];

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return this.notes;
  }

  getMultiNotes?(): SummaryNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return this.multiNotes;
  }

  removeNonApplicable?(): void {}

  setAsApplicable?() {
    this.isApplicable = true;
  }
}

export class InspectionCase extends InspectionCaseDto {
  constructor(data: InspectionCaseDto = {}) {
    super();
    this.title = data.title;
    this.isTitle = data.isTitle;
    this.section = data.section;
    this.isApplicable = data.isApplicable || false;
    this.notes = Array.isArray(data.notes) ? data.notes : [];
    this.multiNotes = Array.isArray(data.multiNotes) ? data.multiNotes : [];
    this.images = data.images || [];
    this.isPassed = data.isPassed !== false ? true : false;
  }
}
